import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { FirstReceiptInfo } from '../../@types/digitalSignature/RefreshDigitalSignatureStatus'
import { useFirstReceiptInfo } from '../../Stores/useFirstReceiptInfo'

export const useFirstReceiptInfoHydration = () => {
  const { setFirstReceiptInfo } = useFirstReceiptInfo()

  const handleFirstReceiptInfoHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    if (data.processData?.firstReceipt?.invoiceId?.length) {
      setFirstReceiptInfo({
        ...data.processData?.firstReceipt,
        status: data.processData?.firstReceipt?.invoiceStatus,
      } as FirstReceiptInfo)
    }
  }

  return { handleFirstReceiptInfoHydration }
}
